// @flow

import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, Fab, Hidden, Popover } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import { setInviteCardOpen } from '../../actions/conversation';

import * as segment from '../../utils/segment';
import { getSnack } from '../../utils/snackbar';
import { users } from '../../services/api/ava';
import AddIcon from '../../../assets/icons/add.svg';
import InviteCard from '../../components/Cards/InviteCard';

const useStyles = makeStyles(theme => ({
  fab: {
    backgroundColor: theme.palette.ava.navy,
    borderRadius: 22,
    boxShadow: 'none',
    color: 'white',
    fontSize: 16,
    fontWeight: 600,
    height: 44,
    marginLeft: 4.5,
    marginRight: 5,
    marginTop: 0,
    padding: '8px 15px',
    textTransform: 'none',
    width: 'auto',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.palette.ava.navy,
      opacity: 0.9,
    },
  },
  icon: {},
  text: { marginLeft: 10 },
  inviteParticipantCard: {
    background: theme.palette.ccMode.backgroundGradient,
    color: 'white',
    height: '100%',
  },
}));

type Props = {
  scribe: boolean,
  theme: Object,
  captionMode?: Object,
  user: Object,
  hideText?: boolean,
};

function AddParticipant(props: Props) {
  const { scribe, theme, hideText } = props;
  const classes = useStyles(theme);
  const { t } = useTranslation();
  const buttonRef = useRef(null);

  const electronCaptionMode = useSelector(state => state.scribeTranscriptUI.electronCaptionMode);
  const isInviteCardOpen = useSelector(state => state.scribeConversation.isInviteCardOpen);
  const dispatch = useDispatch();

  return (
    <>
      <Tooltip title={t('addParticipant.invite')} aria-label="share-link" enterDelay={300} leaveDelay={200}>
        <Fab
          ref={buttonRef}
          variant="extended"
          className={classes.fab}
          onClick={() => {
            dispatch(setInviteCardOpen(!isInviteCardOpen));
          }}
        >
          <img height="22" width="22" alt="add" className={classes.icon} src={AddIcon} />
          {!scribe && !hideText && (
            <Hidden only={['xs', 'sm']}>
              <span className={classes.text}>{t('addParticipant.add')}</span>
            </Hidden>
          )}
        </Fab>
      </Tooltip>
      {!electronCaptionMode && (
        <Popover
          open={isInviteCardOpen}
          anchorEl={buttonRef.current}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            style: {
              marginTop: 8,
              minWidth: 385,
              height: 150,
              background: theme.palette.ccMode.backgroundGradient,
              borderRadius: 8,
            },
          }}
        >
          <div className={classes.inviteParticipantCard}>
            <InviteCard />
          </div>
        </Popover>
      )}
    </>
  );
}

export default withTheme(AddParticipant);
